import {isNil, notNil} from '@megaphonenpm/mputils/src/utils.js';
import {log} from '@megaphonenpm/mputils/src/logfunctions.js';
import {MegaScreen} from "./MegaScreen.js";

export function cloneInstance (themeID, instanceID) {
  let exporter = getExporter(themeID);
  let clone = null;

  if (notNil(exporter)) {
    let instance = exporter.querySelector(`#${instanceID}`);
    clone = notNil(instance) ? instance.cloneNode(true) : null;
  }
  return clone;
}

function getExporter (themeID) {
  let exporter = MegaScreen.globals.themeLoader.getThemeDiv(themeID).querySelector('#exporter');
  if (isNil(exporter)) {
    log(`THEME ERROR: Missing #exporter instance in theme [${MegaScreen.globals.themeService.getTheme(themeID).name}].`);
    return null;
  } else {
    return exporter;
  }
}

/**
 * If a theme by the given themeID has been loaded and meets all requirements for a valid theme,
 * returns true. Otherwise, returns false.
 *
 * @param themeID
 */
export function isGWDThemeValid (themeID) {
  return notNil(getExporter(themeID));
}
